<template>
    <div>
      <div class="Vdialog-mask" v-show="objData.showDialog">
        <div class="dialog-box">
          <div class="dialog-title">告家长书</div>
          <div class="dialog-body">

            


    <div>尊敬的家长朋友们：</div>
    <div>您好！</div>
    <p>&nbsp;&nbsp;为了进一步促进学生的身心健康发展，我校引入了智慧体育设备，旨在利用先进科技手段，让学生在课间能够自主、安全地进行锻炼。该设备通过摄像头进行人脸身份识别，以准确记录学生的运动数据，提供个性化的健康指导。</p>
    <P>&nbsp;&nbsp;我们理解您可能对人脸信息的采集和安全性有所担忧。在此，我们郑重向您说明：</P>
    <P>1.人脸信息的用途：人脸识别仅用于确认学生身份，确保运动数据的准确性和唯一性。我们不会将人脸信息用于任何其他目的，绝不涉及商业用途或第三方共享。</P>
    <div>2. 安全保障措施：</div>
    <P>&nbsp;&nbsp;- 在技术实现的严谨性上，我们严格遵循隐私保护原则，一旦人脸数据处理完成并提取出必要的特征值后，我们立即确保所有原始的、未经处理的人脸图像被彻底移除并安全销毁，以最大程度保障您孩子的隐私安全。</P>
    <P>&nbsp;&nbsp;- 身份识别与成绩记录：提取的人脸特征值仅用于校内学生自主运动时的身份识别和成绩记录，确保每位学生的运动数据准确、安全。</P>
    <P>&nbsp;&nbsp;- 数据加密与存储：所有人脸特征值数据均采用高级加密技术，存储在安全的服务器上，严格遵守国家相关法律法规。只有经过授权的专业人员才能访问，确保信息不泄露、不滥用。</P>
    <P>3. 必要性：通过人脸识别，系统能精准地为每位学生记录运动情况，提供个性化的锻炼建议。这有助于提高学生的运动积极性，促进他们的健康成长；如果信息录入，学生可以以访客身份进行运动，后续无法获取其的相关成绩。</P>
    <P>&nbsp;&nbsp;我们真诚希望得到您的理解与支持，共同为孩子们创造更好的学习和成长环境。如您有任何疑问或建议，欢迎随时与我们联系。</P>
    <P>再次感谢您的配合！</P>
    <div>此致</div>
    <div>敬礼！</div>
    <p>
        <van-checkbox v-model="objData.checked" shape="square">本人已仔细审阅了《告家长书》的全部内容，并在此明确表示同意该设备采用我孩子的人脸图像特征值，作为实现设备人脸身份识别功能的必要手段。</van-checkbox>
    </p>
          </div>
          <div class="dialog-btn-box">
           
            <van-button type="default" round @click="cancel()" style="width:100px">关闭</van-button>
            <van-button type="default" round @click="goNext()" style="width:100px" :disabled="!objData.checked">
                确认
            </van-button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { Toast } from "vant";
  export default {
    name: "VDialog",
    props: {
      objData: {
        type: Object,
      },
    },
    data() {
      return {
      };
    },
    created() { },
    methods: {
      goNext() {
        // Toast.loading({ message: "提交中..." });
        this.objData.showDialog = false;
        this.$emit('closeDisclose')
        // this.$router.push("/myFitness");
      },
      cancel() {
        this.objData.showDialog = false;
        localStorage.removeItem("isChecked");
      },
      countdown() {
        const _this = this;
        const timeClock = setInterval(function () {
          _this.objData.num--;
          if (_this.objData.num === 0) {
            clearInterval(timeClock);
            _this.objData.checked = true;
          }
        }, 1000);
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  .Vdialog-mask {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.5);
  }
  
  .dialog-box {
    padding: 4vw;
    width: 80%;
    height: 80%;
    background: #ffffff;
    box-sizing: border-box;
    border-radius: 2vw;
    font-size: 12px;
    overflow: scroll;
  }
  
  .dialog-title {
    font-size: 14px;
    font-weight: 600;
    text-align: center;
  }
  
  .dialog-body {
    padding: 2vw 0;
  }
  
  .dialog-body p {
    padding: 2vw 0;
  }
  
  .dialog-btn-box {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  
  .dialog-btn {
    padding: 0 2vw;
    height: 10vw;
    line-height: 10vw;
    border-radius: 5vw;
    border: 1px solid #000000;
  }
  
  .confirmButton {
    color: #aaaaaa;
  }
  
  input {
    vertical-align: middle;
  }
  </style>
  